export interface BatchLendCollectionListRequest {
  lendDateFrom: string
  lendDateTo: string
  dueDateFrom: string
  dueDateTo: string
  userId: string
  userTypeCondition: string
  userType: string
  branchType: string
  branchCode: string
  newLineCondition: string
  batchType: string
}

export function BatchLendCollectionListRequestToJSON(
  value: BatchLendCollectionListRequest
): any {
  return {
    lend_date_from: value.lendDateFrom,
    lend_date_to: value.lendDateTo,
    due_date_from: value.dueDateFrom,
    due_date_to: value.dueDateTo,
    user_id: value.userId,
    user_type_condition: value.userTypeCondition,
    user_type: value.userType,
    branch_type: value.branchType,
    branch_code: value.branchCode,
    new_line_condition: value.newLineCondition,
    batch_type: value.batchType
  }
}
